module.exports = __webpack_public_path__ + "img/event1.9015008d.jpg";